import type { ServiceLabel } from './types';

/** BVI is single-service-only per the legacy config. Extend as needed. */
export const BVI_SERVICES: readonly ServiceLabel[] = [
  { key: 'Other', label: 'Other', jurisdiction: 'BVI' },
] as const;